export const defaultUnidadesMedida = () => {
  return {
    PRESEN: [],
    UTEMP: [],
    UPRES: [],
    UVISC: [],
    DL50: [],
    CL50: [],
    uniden: [],
    CAPA: [],
    ANIM: [],
    "TCC-af": [],
  };
}

export default {
  unidades_medida: defaultUnidadesMedida(),
  unidades_medida_cargadas: 0
};
